/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import filters from './filters';

export default combineReducers({
	filters,
});
